export default __webpack_public_path__ + "static/media/popByDiegoFernandes.3b364204.mp3";